<!-- 修改店铺信息 -->
<template>
  <div class="edit white">
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="handleChangeDrawer">
      <div slot="body">
        <div class="pay-mains">
          <el-form ref="form" :model="form" class="demo-ruleForm" label-width="160px" label-position="left">
            <el-row>
              <el-col :span="12">
                <el-form-item class="el-form-item-update" ref="shopName" label="门店名称" prop="shopName">
                  <el-input disabled v-model="form.shopName"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item class="el-form-item-update" ref="businessLicenseName" prop="businessLicenseName" label="营业执照名称：">
                  <el-input v-model="form.businessLicenseName" placeholder="请输入营业执照名称" maxlength="30" :readonly="appInfo.shopBizConfig.yuanyuanFlag"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item class="el-form-item-update" ref="businessLicenseAddress" prop="businessLicenseAddress" label="营业执照住所：">
                  <el-input v-model="form.businessLicenseAddress" placeholder="请输入营业执照住所" maxlength="50" :readonly="appInfo.shopBizConfig.yuanyuanFlag"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item class="el-form-item-update" ref="registerNo" prop="registerNo" label="统一社会信用代码：">
                  <el-input v-model="form.registerNo" placeholder="请输入统一社会信用代码" maxlength="18" :readonly="appInfo.shopBizConfig.yuanyuanFlag"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item class="el-form-item-update" ref="legalName" prop="legalName" label="经营者姓名：">
                  <el-input v-model="form.legalName" placeholder="请输入经营者姓名" maxlength="10" :readonly="appInfo.shopBizConfig.yuanyuanFlag"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item class="el-form-item-update" ref="legalMobile" prop="legalMobile" label="联系电话：">
                  <el-input v-model="form.legalMobile" placeholder="请输入联系电话" maxlength="11" :readonly="appInfo.shopBizConfig.yuanyuanFlag"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item class="el-form-item-update" ref="legalIdCard" prop="legalIdCard" label="身份证号：">
                  <el-input v-model="form.legalIdCard" placeholder="请输入身份证号" maxlength="18" :readonly="appInfo.shopBizConfig.yuanyuanFlag"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <p class="order-title-boxs"><span class="blueBlock"></span><i>证件信息</i></p>
            <div class="idcard">
              <div class="front card-box pb24">
                <imgUpload @file="getFileCardFront" :fileList="legalIdCardFrontUrl" :disabled="appInfo.shopBizConfig.yuanyuanFlag" module="idcard" type="front"></imgUpload>
                <p class="pt16">身份证正面照</p>
              </div>
              <div class="back card-box">
                <imgUpload @file="getFileCarBack" :fileList="legalIdCardBackUrl" :disabled="appInfo.shopBizConfig.yuanyuanFlag" module="idcard" type="reverse"></imgUpload>
                <p class="pt16">身份证反面照</p>
              </div>
            </div>
            <div class="idcard">
                <div class="front card-box">
                  <otherUpload @file="getBusiness" :fileList="form.businessLicense" :disabled="appInfo.shopBizConfig.yuanyuanFlag" module="business"></otherUpload>
                  <p class="pt16">营业执照</p>
                </div>
                <div class="back card-box">
                  <otherUpload @file="getSanitary" :fileList="form.sanitaryPermitUrl" :disabled="appInfo.shopBizConfig.yuanyuanFlag" module="sanitarypermit"></otherUpload>
                  <p class="pt16">卫生许可证</p>
                </div>
              </div>
          </el-form>
        </div>
        <div class="drawer-footer" v-if="!appInfo.shopBizConfig.yuanyuanFlag">
          <div class="btns pr24 pb10">
            <el-button @click="back">取消</el-button>
            <el-button type="primary" v-perm="{key:'shopInfo', value: 'shopInfo:save'}" @click="save">保存</el-button>
          </div>
        </div>
      </div>
    </drawer>
  </div>
</template>

<script>
import drawer from "./drawer";
import imgUpload from "../../components/common/modules/uploads";
import otherUpload from "../../components/common/modules/otherUpload";
import minxin from "../../assets/javascript/minxin.js";
export default {
  data() {
    return {
      addEditShow: false,
      addEditTitle: "",
      form: {
        description: "",
        address: "",
        legalIdCardFrontUrl: '',
        legalIdCardBackUrl: '',
        sanitaryPermitUrl: "",
        businessLicense: "",
        businessLicenseName: '',
        businessLicenseAddress: '',
        registerNo: '',
        //roleIdList: '',
      },
      legalIdCardFrontUrl: '',
      legalIdCardBackUrl: '',
      appInfo: {
        shopBizConfig: {}
      }
    };
  },
  mixins: [minxin],
  components: {
    drawer,
    imgUpload,
    otherUpload
  },

  computed: {},

  created() {
    this.init();
  },
  methods: {
    back() {
      this.$refs["form"].resetFields();
      this.addEditShow = false;
    },
    init() {
      this.$on("set", function(id) {
        Object.assign(this.$data, this.$options.data());
        this.appInfo = this.$store.getters.ShopInfo
        console.log(this.appInfo);
        this.addEditTitle = "门店信息";
        this.$api.get(this.$url.shop.get, {
            id: id
          }).then(res => {
            if (res) {
              this.legalIdCardFrontUrl = res.legalIdCardFrontUrl;
              this.legalIdCardBackUrl = res.legalIdCardBackUrl;
              this.addEditShow = true;
              this.form = res;
            }
          }).catch(error => {});
      });
    },
    handleChangeDrawer(val) {
      this.$refs["form"].resetFields();
      this.addEditShow = false;
    },
    // 保存
    save() {
      this.$refs.form.validate((valid, object) => {
        if (valid) {
          if (this.form.registerNo && !/^[A-Za-z0-9]+$/.test(this.form.registerNo)) { 
            this.$message.warning("统一社会信用代码必须是数字或字母");
            return false;
          }
          this.$api.post(this.$url.shop.save, {
            businessLicenseAddress: this.form.businessLicenseAddress,
            businessLicenseName: this.form.businessLicenseName,
            registerNo: this.form.registerNo,
            legalName: this.form.legalName,
            legalMobile: this.form.legalMobile,
            legalIdCard: this.form.legalIdCard,
            id: this.form.id,
            legalIdCardFrontUrl: this.form.legalIdCardFrontUrl,
            legalIdCardBackUrl: this.form.legalIdCardBackUrl,
            businessLicense: this.form.businessLicense,
            sanitaryPermitUrl: this.form.sanitaryPermitUrl,
          }).then(res => {
            if (res) {
              this.$api.success();
              this.addEditShow = false;
              this.$refs["form"].resetFields();
              this.$emit("handleChange", false);
            }
          });
        } else {
          this.scrollView(object);
        }
      });
    },
    getFileCardFront(res) {
      //身份证正面
      if (this.form.legalIdCardFrontUrl) {
        this.ossMerchatDelImg({imgUrl: this.form.legalIdCardFrontUrl});
      }
      this.form.legalIdCardFrontUrl = res.oldImgUrl;
      this.legalIdCardFrontUrl = res.newImgUrl;
    },
    getFileCarBack(res) {
      //身份证反面
      if (this.form.legalIdCardBackUrl) {
        this.ossMerchatDelImg({imgUrl: this.form.legalIdCardBackUrl});
      }
      this.form.legalIdCardBackUrl = res.oldImgUrl;
      this.legalIdCardBackUrl = res.newImgUrl;
    },
    getBusiness (res) {
      // 营业执照
      if (this.form.businessLicense) {
        this.ossMerchatDelImg({imgUrl: this.form.businessLicense});
      }
      this.form.businessLicense = res;
    },
    getSanitary (res) {
      // 卫生许可证
      if (this.form.sanitaryPermitUrl) {
        this.ossMerchatDelImg({imgUrl: this.form.sanitaryPermitUrl});
      }
      this.form.sanitaryPermitUrl = res;
    },
    // //滚动到指定位置
    scrollView(object) {
      for (let i in object) {
        let dom = this.$refs[i];
        dom.$el.scrollIntoView({
          block: "center",
          behavior: "smooth"
        });
        break;
      }
    }
  }
};
</script>
<style scoped lang="less">
@import "../../assets/css/edit.less";
.pay-mains {
  padding: 0;
  /deep/ .el-form {
    padding-bottom: 20px;
  }
}
.idcard {
  display: flex;
  margin-top: 10px;
  margin-left: 24px;
  .card-box {
    text-align: center;
  }
  .back {
    margin-left: 80px;
  }
}
</style>